"use strict";function _classCallCheck(a,b){if(!(a instanceof b))throw new TypeError("Cannot call a class as a function")}function _defineProperties(a,b){for(var c,d=0;d<b.length;d++)c=b[d],c.enumerable=c.enumerable||!1,c.configurable=!0,"value"in c&&(c.writable=!0),Object.defineProperty(a,c.key,c)}function _createClass(a,b,c){return b&&_defineProperties(a.prototype,b),c&&_defineProperties(a,c),Object.defineProperty(a,"prototype",{writable:!1}),a}var topInview=/*#__PURE__*/function(){function a(b){_classCallCheck(this,a),this.el=document.querySelectorAll(b)}return _createClass(a,[{key:"_position",value:function _position(){Math.floor(.8*window.innerHeight)}},{key:"addClassJsInview",value:function addClassJsInview(){for(var c=0;c<this.el.length;c++){var a=Math.floor(this.el[c].getBoundingClientRect().top),b=Math.floor(1*window.innerHeight);a<b&&this.el[c].classList.add("js-inview")}}}]),a}();(function a(){var b=new topInview(".c-new__ttlWrap");b.addClassJsInview();var c=new topInview(".c-new__container-textWrap");c.addClassJsInview();var d=new topInview(".new__taste-textWrap");d.addClassJsInview();var e=new topInview(".new__product-wrap");e.addClassJsInview();var f=new topInview(".new__art-ttl");f.addClassJsInview();var g=new topInview(".new__art-profile");g.addClassJsInview();var h=new topInview(".new__art-dev");h.addClassJsInview();var j=new topInview(".new__art-bg");j.addClassJsInview();for(var k,l=document.querySelectorAll(".cover-slide"),m=document.querySelectorAll(".new__taste-image"),n=Math.floor(.8*window.innerHeight),o=0;o<l.length;o++)k=Math.floor(l[o].getBoundingClientRect().top),k<n&&l[o].classList.add("inview");for(var p,q=0;q<m.length;q++)p=Math.floor(m[q].getBoundingClientRect().top),p<n&&m[q].classList.add("new-fade-in");window.addEventListener("scroll",a)})(),function(){var a=document.querySelectorAll(".js-parallax");a.forEach(function(a){gsap.fromTo(a.querySelector("img"),{y:0},{y:-80,// y方向-に60px移動させる
ease:"none",// イージングなし
scrollTrigger:{trigger:a,// ScrollTriggerの開始位置を計算するために使用される要素
start:"top bottom",// 1つ目の値がtriggerで指定した要素の開始位置　2つ目の値が画面の開始位置
end:"bottom top",// 1つ目の値がtriggerで指定した要素の終了位置　2つ目の値が画面の終了位置
scrub:1// 要素を1秒遅れで追従させる
// markers: true, // 開始位置、終了位置を調整確認する際に使用します
}})})}(),function(){var a=document.querySelectorAll(".js-parallax");a.forEach(function(a){gsap.fromTo(a.querySelector("img"),{y:0},{y:-80,// y方向-に60px移動させる
ease:"none",// イージングなし
scrollTrigger:{trigger:a,// ScrollTriggerの開始位置を計算するために使用される要素
start:"top bottom",// 1つ目の値がtriggerで指定した要素の開始位置　2つ目の値が画面の開始位置
end:"bottom top",// 1つ目の値がtriggerで指定した要素の終了位置　2つ目の値が画面の終了位置
scrub:1// 要素を1秒遅れで追従させる
// markers: true, // 開始位置、終了位置を調整確認する際に使用します
}})})}();
//# sourceMappingURL=../../_cache/_maps/scripts.js.map

class MovieEvent {
  constructor(el, opt){
    this.el = el;
    this.flag = true;
    if($(this.el).length > 0){
      this.setting();
    }
  }
  setting() {
    let optionsAll = {
      root: null,
      threshold: [0, 0.3, 0.5, 1]
    }
    const observerAll = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(!entry.isIntersecting){
          this.movieStop(item);
        }
        if(entry.intersectionRatio >= 0.3) {
          this.movieStart(item);
        }
      });
    }, optionsAll);
    const inviewItem = document.querySelectorAll(this.el);
    inviewItem.forEach((e)=>{
      observerAll.observe(e);
    });

    if($(".volumeSwitch").length) {
      this.volumeSwitch(this.el);
    }
  }
  movieStart(item){
    $(item).get(0).play();
    this.movieEnded(item);
  }
  movieStop(item){
    $(item).get(0).pause();
    $(item).get(0).currentTime = 0;
  }
  movieEnded(item){
    $(item).on("ended", (e)=> {
      var $this = $(e.currentTarget);
      $this.get(0).currentTime = 0;
      $this.get(0).play();
      // this.nextScene();
    });
  }
  volumeSwitch(ele){
    $(".volumeSwitch").on({
      click: function() {
        if(this.flag == true) {
          $(ele).prop('muted', true);
          this.flag = false;
        } else {
          $(ele).prop('muted', false);
          this.flag = true;
        }
        $(".volumeSwitch").toggleClass('is-active');
      }
    });
  }
}

let movieEvent = new MovieEvent('.js-movie');

(function() {
  document.querySelectorAll("a").forEach(function(ele){
    ele.setAttribute("target", "_blank");
  })
}())